"use client";

import { ChevronRight, Close } from "@mui/icons-material";
import { Box, Button, DialogContent, DialogTitle, IconButton, Stack, SwipeableDrawer, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  /** When set, shows a back control before the title (RTL chevron). */
  onBack?: () => void;
  title: string;
  subtitle?: string;
  children: ReactNode;
};

export default function ProductBottomSheet({ open, onClose, onBack, title, subtitle, children }: Props) {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableDiscovery
      disableSwipeToOpen
      hysteresis={0}
      swipeAreaWidth={0}
      transitionDuration={{ appear: 200, enter: 220, exit: 160 }}
      PaperProps={{
        sx: (theme) => ({
          mx: "auto",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minHeight: "80%",
          maxHeight: "90%",
          [theme.breakpoints.up("md")]: {
            width: theme.breakpoints.values.md,
          },
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
        }),
      }}
      ModalProps={{
        keepMounted: false,
        sx: {
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0,0,0,0.3)",
            backdropFilter: "blur(4px)",
          },
        },
      }}
    >
      <DialogTitle component="div" sx={{ p: 0, flexShrink: 0 }}>
        <Stack>
          <Box width={40} height={4} sx={{ borderRadius: 50, bgcolor: "grey.300", opacity: 0.7, mx: "auto", mt: 1.25 }} />
          <Stack
            direction="row"
            alignItems="center"
            gap={0.5}
            sx={{ px: { xs: 2, sm: 2.5 }, pt: 1.75, pb: subtitle ? 1.25 : 2 }}
          >
            {onBack ? (
              <IconButton onClick={onBack} aria-label="بازگشت" edge="start" sx={{ ml: -1 }}>
                <ChevronRight />
              </IconButton>
            ) : null}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="h6" component="h2" sx={{ lineHeight: 1.4, fontWeight: 800, fontSize: "1.05rem" }}>
                {title}
              </Typography>
              {subtitle ? (
                <Typography variant="body2" color="grey.600" sx={{ mt: 0.4, fontSize: "0.8125rem", lineHeight: 1.55 }}>
                  {subtitle}
                </Typography>
              ) : null}
            </Box>
            <IconButton onClick={onClose} aria-label="بستن" edge="end" sx={{ mr: -0.75 }}>
              <Close />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 2, sm: 2.5 }, pb: 2, pt: 0, flex: 1, overflow: "auto" }}>{children}</DialogContent>
      <Box sx={{ px: { xs: 2, sm: 2.5 }, pb: 2.5, pt: 1, flexShrink: 0 }}>
        <Button fullWidth variant="contained" size="large" disableElevation onClick={onClose} sx={{ borderRadius: 50 }}>
          بستن
        </Button>
      </Box>
    </SwipeableDrawer>
  );
}
